<!-- 车辆管理界面 -->
<template>
  <div class="access-record-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            :data="tableData"
            :option="tableOption"
            :page="page"
            @row-cancle="closeDialog"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @current-change="selectPage"
            @size-change="changeSize"
          >
            <!-- 表格按钮 自定义 -->
            <!-- 预约状态-->
            <template slot="search_status">
              <div>
                <el-select v-model="searchParams.status" placeholder="请选择">
                  <el-option
                    v-for="item in subscribeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>

            <!-- 表格操作按钮 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-Detail"
                  @click="handleView(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="审批"
                placement="top"
                popper-class="tooltip-draw"
                v-if="scope.row.status !== 2"
              >
                <el-button
                  :disabled="scope.row.status == 2"
                  type="text"
                  icon="iconfont icon-xiugai"
                  @click="handleApproval(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
    <!--详情-->
    <appPanel
      :width="780"
      class="app-panel"
      :isExpand="showPanel"
      @cancel="handleClosePanel"
      title="访客预约记录详情"
    >
      <el-scrollbar style="height: 100%">
        <div class="panel-content">
          <h3 class="info-title">基本信息</h3>
          <div class="content-top">
            <div class="detail-info">
              <div class="info-item">
                <span class="label">预约时间：</span>
                <span class="item-value">{{ form.visitDate }}</span>
              </div>
              <div class="info-item">
                <span class="label">预约人：</span>
                <span class="item-value">{{ form.appointmentPersonName }}</span>
              </div>
              <div class="info-item">
                <span class="label">预约来访时间：</span>
                <span class="item-value">{{
                  form.startTime + "~" + form.endTime
                }}</span>
              </div>
              <div class="info-item">
                <span class="label">拜访人：</span>
                <span class="item-value">{{ form.visitorReceiverName }}</span>
              </div>
              <div class="info-item">
                <span class="label">签入时间：</span>
                <span class="item-value">{{ form.signTime }}</span>
              </div>
              <div class="info-item">
                <span class="label">签入人：</span>
                <span class="item-value">{{ form.signUserName }}</span>
              </div>
              <!-- <div class="info-item">
                <span class="label">签入时间：</span>
                <span class="item-value">{{ form.signTime }}</span>
              </div> -->
              <div class="info-item">
                <span class="label">签离时间：</span>
                <span class="item-value">{{ form.leaveTime }}</span>
              </div>

              <div class="info-item">
                <span class="label">签离人：</span>
                <span class="item-value">{{ form.leaveUser }}</span>
              </div>
              <div class="info-item">
                <span class="label">来访事由：</span>
                <span class="item-value">{{ form.visitCause }}</span>
              </div>
              <div class="info-item">
                <span class="label">预约状态：</span>
                <span class="item-value">{{ statusList[form.status] }}</span>
              </div>
              <div class="info-item">
                <span class="label">签离时间：</span>
                <span class="item-value">{{ form.leaveTime }}</span>
              </div>
            </div>
          </div>
          <h3 class="info-title" style="margin-bottom: 15px">访客信息</h3>
          <el-table
            :data="visitorData"
            :stripe="false"
            size="mini"
            :border="false"
            :highlight-current-row="false"
          >
            <el-table-column
              type="index"
              align="center"
              header-align="center"
              label="序号"
            />
            <el-table-column
              prop="imageUrl"
              label="照片"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="personName"
              label="访客姓名"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="personSex"
              label="性别"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="personPhone"
              label="手机号码"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="idCardNo"
              label="身份证号"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="plateNumber"
              label="车辆号牌"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <template slot="empty">
              <div class="table-empty">
                <img src="@/common/assets/images/empty.svg" />
                <p>{{ $t("base.label.empty") }}</p>
              </div>
            </template>
          </el-table>
        </div>
      </el-scrollbar>

      <div slot="footer">
        <el-button @click="handleClosePanel">关闭</el-button>
      </div>
    </appPanel>
  </div>
</template>

<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/subscribeTable";
export default {
  components: {
    appPanel,
  },
  data() {
    return {
      form: {},
      showPanel: false,
      viewerInstance: null,
      tableOption: tableOption(),
      getTimeOut: null,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      searchParams: {},
      // 新增/修改表格
      subLoading: false,
      title: "",
      showAddOrEditPanel: false,
      // 下拉选项信息
      visitorData: [],
      statusList: {
        1: "待审批",
        2: "已通过",
        3: "已拒绝",
        4: "已签入",
        5: "已签离",
      },
      subscribeList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "待审批",
          value: "1",
        },
        {
          label: "已通过",
          value: "2",
        },
        {
          label: "已拒绝",
          value: "3",
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  beforeDestroy() {},
  methods: {
    // getDateStr(date, format) {
    //   return date ? getDateStr(date, format) : "无";
    // },
    showViewer(url, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },

    // TODO获取列表
    getList() {
      const params = {};
      params.pageNumber = this.page.currentPage;
      params.pageSize = this.page.pageSize;
      params.visitType = 2;

      params.startTime = this.searchParams.startTime;
      params.endTime = this.searchParams.endTime;
      params.appointmentStartDate = this.searchParams.appointmentStartDate;
      params.appointmentEndDate = this.searchParams.appointmentEndDate;
      params.status = this.searchParams.status;
      params.visitorName = this.searchParams.visitorsName;
      params.appointmentPersonName = this.searchParams.appointmentPersonName;

      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.visitorSubscribe, params).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!res.success) {
          // this.$message.error(res.msgContent);
          this.tableData = [
            {
              visitId: 70,
              visitType: 1,
              visitCode: "20230321151550000001",
              appointmentPerson: "1",
              visitDate: "2023-03-22T00:00:00.000+0800",
              appointmentDates: "2023-03-22T09:13:00.000+0800",
              startTime: "2023-03-22T09:13:00.000+0800",
              endTime: "2023-03-22T21:13:00.000+0800",
              visitCause: "参观",
              visitorReceiver: "1",
              visitorReceiverName: "超级管理员",
              visitorsNumber: "2",
              visitorsName: "罗平,实施罗平",
              status: 2,
              invitationTime: "2023-03-21T15:15:50.000+0800",
              passPersonnelList: [
                {
                  imageUrl: "",
                  personName: "Licy",
                  personSex: "女",
                  personPhone: "18152877150",
                  idCardNo: "430581199010101010",
                  plateNumber: "暂无",
                },
              ],
            },
            {
              visitId: 62,
              visitType: 1,
              visitCode: "20230210205347000001",
              appointmentPerson: "1",
              appointmentDates: "2023-02-10T20:53:00.000+0800",
              visitDate: "2023-02-10T00:00:00.000+0800",
              startTime: "2023-02-10T20:53:00.000+0800",
              endTime: "2023-02-10T23:53:00.000+0800",
              visitCause: "test",
              visitorReceiver: "1",
              visitorReceiverName: "超级管理员",
              visitorsNumber: "2",
              visitorsName: "张三,张三",
              status: 1,
              invitationTime: "2023-02-10T20:53:47.000+0800",
              passPersonnelList: [
                {
                  imageUrl: "",
                  personName: "Licy",
                  personSex: "女",
                  personPhone: "18152877150",
                  idCardNo: "430581199010101010",
                  plateNumber: "暂无",
                },
              ],
            },
          ];
          this.page.total = 2;
          return;
        }
        this.tableData = res.data ? Object.freeze([...res.data.list]) : [];
        this.page.total = res.data ? res.data.total : 0;
      });
    },

    handleView(row, index) {
      // this.showPanel = true;
      // this.form = row;

      this.$fetch(api.showVisit, { visitId: row.visitId, visitType: 2 }).then(
        (res) => {
          if (!res.success) {
            // this.$message.error(res.msgContent);
            // 失败
            this.showPanel = true;
            this.form = {
              appointmentPerson: "bb475069580d44338bf18c3ad528ffc7",
              endTime: "2023-01-30T15:30:00.000+0800",
              leaveTime: "2023-04-06T14:44:35.000+0800",
              leaveUser: "1",
              leaveUserName: "超级管理员",
              passPersonnelList: [
                {
                  imageUrl: "",
                  personName: "Licy",
                  personSex: "女",
                  personPhone: "18152877150",
                  idCardNo: "430581199010101010",
                  plateNumber: "暂无",
                },
              ],
              passPersonnelSize: 0,
              signTime: "2023-04-06T14:32:23.000+0800",
              signUser: "1",
              signUserName: "超级管理员",
              startTime: "2023-01-30T10:15:00.000+0800",
              status: 2,
              twoDimensionCode:
                "/9j/4AAQSkZJRgABAgAAAQABAAD/2wBDAAgGBgcGBQgHBwcJC",
              visitCause: "到访公干",
              visitCode: "20230130154318000001",
              visitDate: "2023-01-30T00:00:00.000+0800",
              visitId: 36,
              visitType: 2,
              visitorReceiver: "1",
              visitorReceiverName: "超级管理员",
              visitorReceiverPhone: "123123",
              visitorsName: "王小磊",
              visitorsNumber: "1",
            };
            // 格式化时间数据
            this.form.visitDate = Dates.format(this.form.visitDate);
            this.form.startTime = Dates.format(this.form.startTime);
            this.form.endTime = Dates.format(this.form.endTime);
            this.form.signTime = Dates.format(this.form.signTime);
            this.form.leaveTime = Dates.format(this.form.leaveTime);
            this.visitorData = this.form.passPersonnelList;
            return;
          }
          // 成功
          this.showPanel = true;
          this.form = res.data;
        }
      );
    },
    //关闭详情
    handleClosePanel() {
      this.showPanel = false;
    },

    closeDialog() {},

    // 查询按钮事件
    searchResult(param) {
      console.log("--searchResult()--param:--", param);
      // appointmentDates 预约时间  startTime 来访时间 appointmentPersonName 预约人 visitorsName 访客姓名  status 预约状态
      this.searchParams = param;

      if (param.startTime && param.startTime.length > 0) {
        // 来访时间
        this.searchParams.startTime = param.startTime[0];
        this.searchParams.endTime = param.startTime[1];
      }
      if (param.appointmentDates && param.appointmentDates.length > 0) {
        // 预约时间
        this.searchParams.appointmentStartDate = param.appointmentDates[0];
        this.searchParams.appointmentEndDate = param.appointmentDates[1];
      }
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.searchParams.startTime = "";
      this.searchParams.endTime = "";
      this.searchParams.appointmentStartDate = "";
      this.searchParams.appointmentEndDate = "";

      this.searchParams.status = "";
      this.searchParams.visitorName = "";
      this.searchParams.appointmentPersonName = "";
      this.searchParams.pageNumber = 1;
      this.searchParams.pageSize = this.page.pageSize;
      this.searchParams.visitType = 2;

      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleApproval(row) {
      console.log("---审批--row:--", row);
      if (row.status == 2) return;
      this.visitId = row.visitId;
      this.$confirm("审批", "审批", {
        confirmButtonText: "通过",
        cancelButtonText: "拒绝",
        type: "warning",
        distinguishCancelAndClose: true,
      })
        .then((res) => {
          this.examine("2");
        })
        .catch((e) => {
          if (e == "cancel") {
            this.examine("3");
          }
        });
    },
    examine(status) {
      //
      // this.$fetch(api.examineVisit, {
      //   visitId: this.visitId,
      //   status: status,
      // }).then((res) => {
      //   if (!res.success) {
      //     this.$message.error(res.msgContent);
      //     // 失败
      //     return;
      //   }
      //   // 成功
      //   this.$socMessage.success(status == "2" ? "审核通过" : "审核不通过");
      //   this.getList();
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-content {
  .info-title {
    color: #fff;
    border-left-width: 3px;
    border-left-style: solid;
    padding-left: 10px;
    border-left-color: #407aee;
  }
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.access-record-container {
  width: 100%;
  height: 100%;

  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}

.car-info-box {
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 18px;
    display: flex;
    width: 100%;
    .el-form-item__content {
      flex: 1;
    }
  }
}
</style>
